import React, { useEffect, useState } from "react";
import "./header.scss";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    handleScroll(); // check once on mount
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="desktop-nav">
        <div className="container">
          <div className="logo-container">
            <a href="/">
              <img src="/images/SV-logo2.png" alt="Logo" />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="menu">
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/collection">Collection</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://wa.me/918655981117"
                  rel="noreferrer"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div className="gst">
            <p>27AADPV1396D1ZK</p>
          </div>

          {/* Mobile Menu Button */}
          <div
            className={`menu-button ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* Mobile Drawer */}
      <div className={`mobile-drawer ${menuOpen ? "open" : ""}`}>
        {/* Close Button */}
        <button className="drawer-close" onClick={() => setMenuOpen(false)}>
          ✕
        </button>

        <ul>
          <li onClick={() => setMenuOpen(false)}>
            <a href="/">Home</a>
          </li>
          <li onClick={() => setMenuOpen(false)}>
            <a href="/collection">Collection</a>
          </li>
          <li onClick={() => setMenuOpen(false)}>
            <a href="/contact">Contact Us</a>
          </li>
        </ul>
      </div>

      {/* Overlay for premium effect */}
      {menuOpen && (
        <div className="overlay" onClick={() => setMenuOpen(false)} />
      )}
    </header>
  );
};

export default Header;
